export function formatTime(rawdate){
  let d = new Date( rawdate )
  return (d.getMonth() + 1) + '/' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes()
}

export function formatDate(rawdate){
  let d = new Date( rawdate )
  return d.toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"})
}